module.exports = __webpack_public_path__ + "static/00031.d097bd22.jpg";